module.exports = __webpack_public_path__ + "static/img/rrrr_05.b31bb85.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/rrrr_05.png
// module id = wbAm
// module chunks = 1